import React from "react";
import { CheckCircle2, AlertCircle, HelpCircle } from "lucide-react";

interface ConfidenceBadgeProps {
  level: "high" | "medium" | "low";
}

export function ConfidenceBadge({ level = "high" }: ConfidenceBadgeProps) {
  const configs = {
    high: {
      bg: "bg-emerald-50/80",
      text: "text-emerald-700",
      border: "border-emerald-200/60",
      icon: CheckCircle2,
      label: "High Confidence",
    },
    medium: {
      bg: "bg-amber-50/80",
      text: "text-amber-700",
      border: "border-amber-200/60",
      icon: HelpCircle,
      label: "Medium Confidence",
    },
    low: {
      bg: "bg-rose-50/80",
      text: "text-rose-700",
      border: "border-rose-200/60",
      icon: AlertCircle,
      label: "Low Confidence",
    },
  };

  const config = configs[level];
  const Icon = config.icon;

  return (
    <div
      className={`
      inline-flex items-center gap-1.5 px-2 py-1 rounded-md
      border ${config.border} ${config.bg} ${config.text}
      transition-colors duration-200
    `}
    >
      <Icon className="w-3.5 h-3.5 stroke-[2]" />
      <span className="text-[11px] font-medium tracking-tight">{config.label}</span>
    </div>
  );
}
